import Chat from "./Chat";

export default Chat;
